module.exports = require('./domains.json')
